import { DisciplineOutput } from "@/api/gql/graphql";
import { create } from "zustand";

type DisciplineStore = {
  selectedDiscipline: DisciplineOutput | null;
  setSelectedDiscipline: (discipline: DisciplineOutput | null) => void;
};

export const useDisciplineStore = create<DisciplineStore>((set) => ({
  selectedDiscipline: null,
  setSelectedDiscipline: (discipline) => set({ selectedDiscipline: discipline }),
}));
